import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'
import { AuthService } from '../services/auth/auth.service'

const RETRIED_ONCE = new HttpContextToken<boolean>(() => false)

@Injectable({
  providedIn: 'root',
})
export class AuthRefreshTokenInterceptor implements HttpInterceptor {
  private readonly debug: boolean = true

  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(catchError((error) => this.handleResponseError(error, req, next)))
  }

  private handleResponseError(
    error: any,
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (error instanceof HttpErrorResponse && error.status === 401) {
      this.debugLog('[AuthRefreshTokenInterceptor] Refreshing token')

      if (req.context.get(RETRIED_ONCE)) {
        this.debugLog(`[AuthRefreshTokenInterceptor] Retried already.`)
        return throwError(() => error)
      }

      return this.authService.refreshSession().pipe(
        switchMap((result) => {
          this.debugLog(
            `[AuthRefreshTokenInterceptor] Refresh result success=${result?.success}`
          )

          if (result?.success && result?.token) {
            const retried = req.clone({
              setHeaders: {
                Authorization: `Bearer ${result.token}`,
              },
              context: req.context.set(RETRIED_ONCE, true),
            })
            return next
              .handle(retried)
              .pipe(
                catchError((error) =>
                  this.handleResponseError(error, retried, next)
                )
              )
          }

          return throwError(() => error)
        })
      )
    } else {
      this.debugLog(
        `[AuthRefreshTokenInterceptor] A request failed with HTTP ${error.status}`
      )
      return throwError(() => error)
    }
  }

  private debugLog(message: string) {
    if (this.debug) {
      console.log(message)
    }
  }
}
